import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '~shared/modules/application-event/constants';

export class CheckoutFunnelTrackingApplicationEventModel implements ApplicationEvent {

  type = ApplicationEventType.CheckoutStepper;

  constructor(
    private label: string
  ) {
  }

  getPayload(): any {
    return {
      label: this.label,
    };
  }
}
